import { AxiosError, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';
import ApiCourier, { API_ERROR_CODE } from '@bharatpe/api-courier';
import { isProd, handleLogOut } from 'utils/Utils';
import { TOKEN_SESSION_KEY, APP_VERSION } from 'utils/CONSTANT';
import { API_ENV_CONFIG } from './apiConfig';

import { IError, IGetParams } from 'types';
import { getURLParameter } from 'utils/nativeSupport';

const apiEnv = isProd() ? API_ENV_CONFIG.prod : API_ENV_CONFIG.dev;

const Request = ApiCourier.create(
	{
		baseURL: apiEnv.SWIPE_BASE_PATH,
		headers: { 'Content-Type': 'application/json' },
	},
	{
		maxRetryCount: 3,
		retryStatusCodeList: [401, 403],
		tokenStorageKey: TOKEN_SESSION_KEY,
		tokenHeaderKey: 'token',
		versionStorageKey: APP_VERSION,
	},
);

const Request1 = ApiCourier.create(
	{
		baseURL: apiEnv.SWIPE_BASE_PATH,
		headers: { 'Content-Type': 'application/json' },
	},
	{
		maxRetryCount: 3,
		retryStatusCodeList: [401, 403],
		tokenStorageKey: TOKEN_SESSION_KEY,
		tokenHeaderKey: 'token',
		versionStorageKey: APP_VERSION,
	},
);

const Request2 = ApiCourier.create(
	{
		baseURL: apiEnv.SWIPE_BASE_PATH,
		headers: { 'Content-Type': 'application/json' },
	},
	{
		maxRetryCount: 3,
		retryStatusCodeList: [401, 403],
		tokenStorageKey: TOKEN_SESSION_KEY,
		tokenHeaderKey: 'token',
		versionStorageKey: APP_VERSION,
	},
);

const serializeError = (error: AxiosError): IError => {
	const { response } = error;
	if (!response) throw error;
	const { status, statusText, data } = response;
	const { message } = data;
	let errorMsg = '';
	try {
		errorMsg = JSON.parse(message).error.debug_msg;
	} catch (e) {
		errorMsg = message;
	}
	const errorObj = {
		name: 'API ERROR',
		message: errorMsg || statusText || `API FAILED (${status})`,
		code: status.toString(),
		stack: JSON.stringify(error.toJSON()),
	};
	return errorObj;
};

const tokenHeaderInterceptor = (config: AxiosRequestConfig): AxiosRequestConfig => {
	if (config.headers['NO_HEADER'] === true) {
		delete config.headers['NO_HEADER'];
		return config;
	}

	if (config?.url?.includes('v1/merchant/transactions')) {
		const principal_merchant_id = getURLParameter(window.location.href, 'principal_merchant_id') || '';
		const principal_store_id = getURLParameter(window.location.href, 'principal_store_id') || '';
		if (principal_merchant_id) config.headers['principal_merchant_id'] = principal_merchant_id;
		if (principal_store_id) config.headers['principal_store_id'] = principal_store_id;
	}

	return config;
};

const onErrorInterceptor = (error: AxiosError): IError => {
	if (error?.code === API_ERROR_CODE.TOKEN_EXPIRED) {
		handleLogOut();
		return error as IError;
	}

	return serializeError(error);
};

Request.interceptors.authRequest.use(tokenHeaderInterceptor);
Request.interceptors.authResponse.use(undefined, onErrorInterceptor);

const tokenHeaderInterceptor1 = (config: AxiosRequestConfig): AxiosRequestConfig => {
	config.headers['Authorization'] = 'Bearer eea80e9c289d47999de991849e2aa360';
	config.headers['token'] = 'eea80e9c289d47999de991849e2aa360';
	return config;
};

Request1.interceptors.authRequest.use(tokenHeaderInterceptor1);
Request1.interceptors.authResponse.use(undefined, onErrorInterceptor);

const tokenHeaderInterceptorPincodeFromMid = (config: AxiosRequestConfig): AxiosRequestConfig => {
	if (config.headers['NO_HEADER'] === true) {
		delete config.headers['NO_HEADER'];
		return config;
	}
	return config;
};

Request2.interceptors.authRequest.use(tokenHeaderInterceptorPincodeFromMid);
Request2.interceptors.authResponse.use(undefined, onErrorInterceptor);
interface IAPIResponse<T> {
	success: boolean;
	message: string;
	data: T;
	msg?: string;
	status_code?: string;
	status?: boolean;
}

const extractor = <T,>(response: AxiosResponse<IAPIResponse<T>>) => {
	const { status, data, statusText } = response;
	if (status !== 200) throw new Error(statusText);
	//if (!data || !data.success) throw new Error(data.message);
	return {
		...data.data,
		...{ status_code: data?.status_code ?? data?.status, api_msg: data?.msg ?? data?.message },
	};
};

const returnAPIextractor = <T,>(response: AxiosResponse<IAPIResponse<T>>) => {
	const { status, data, statusText } = response;
	if (status !== 200) throw new Error(statusText);
	//if (!data || !data.success) throw new Error(data.message);
	return { data: data.data, ...data.data, ...{ status_code: data.status_code, api_msg: data.msg || data.message } };
};

const extractor1 = <T,>(response: AxiosResponse<IAPIResponse<T>>) => {
	const { status, data, statusText } = response;
	if (status !== 200) throw new Error(statusText);
	//if (!data || !data.success) throw new Error(data.message);
	return response.data;
};

export const Get = <T,>(path: string, params?: Partial<IGetParams>, cancelToken?: CancelToken): Promise<T> =>
	Request.get<IAPIResponse<T>>(path, { params, cancelToken }).then(extractor);

export const GetReturn = <T,>(path: string, params?: Partial<IGetParams>, cancelToken?: CancelToken): any =>
	Request.get<IAPIResponse<T>>(path, { params, cancelToken }).then(returnAPIextractor);

export const GetPincodeFromMID = <T,>(path: string, params?: Partial<IGetParams>, cancelToken?: CancelToken): any =>
	Request2.get<IAPIResponse<T>>(path, { params, cancelToken }).then(extractor1);

export const GetStage = <T,>(path: string, params?: Partial<IGetParams>, cancelToken?: CancelToken): Promise<T> =>
	Request1.get<IAPIResponse<T>>(path, { params, cancelToken }).then(extractor);

export const PostStage = <T,>(path: string, payload: unknown, cancelToken?: CancelToken): Promise<T> =>
	Request1.post<IAPIResponse<T>>(path, payload, { cancelToken }).then(extractor);

export const GetAddress = (path: any, params?: any, cancelToken?: CancelToken): any =>
	Request.get(path, { params, cancelToken }).then(extractor1);

export const Post = <T,>(path: string, payload: unknown, cancelToken?: CancelToken): Promise<T> =>
	Request.post<IAPIResponse<T>>(path, payload, { cancelToken }).then(extractor);

export const PostCenter = <T,>(path: string, payload: unknown, cancelToken?: CancelToken): any =>
	Request.post<IAPIResponse<T>>(path, payload, { cancelToken }).then(extractor1);

export { apiEnv };
